import React from "react"

function Footer(props) {
    return <footer style={{textAlign: 'center'}}><hr/>تمام حقوق مادی و معنوی برای تیم سازنده می باشد</footer>
}

export default Footer
